export const CLUSTERING_STORAGE_KEY = "mapClusteringEnabled";
export const TRANSFER_REPORT_SERVICE_TYPES_KEY = "transferReportServiceTypes";
